import Button from "@/common/components/Button"
import useLogOut from "@/common/hooks/useLogOut"
import { LogOutIcon } from "lucide-react"

const AccessDenied = () => {
  const { logOut } = useLogOut()

  return (
    <div className={'flex w-screen h-screen flex-col items-center justify-center gap-3'}>
      <img className='mt-auto' src="/Logo.svg" />
      <div className="mt-8">
        <img src="/locked_content.gif" className="shrink-0 w-[305px]" />
      </div>
      <div className="flex flex-col items-center -mt-16 p-8">
        <p className="font-bold text-xl mb-2">Acesso negado</p>
        <p className="text-sm italic font-light">Seu perfil não possui permissões para acessar este sistema.</p>
        <p className="text-sm italic font-light">Entre em contato com o seu Gestor para solicitar acesso.</p>
        <Button className="mt-4" variant="outline-error" onClick={() => logOut()}> <LogOutIcon /> Sair </Button>
      </div>
      <div className="flex flex-col items-center mb-auto mt-8">
        <span className="text-[10px] italic font-light">Desenvolvido por</span>
        <img src='/Avantsoft.svg' className="h-[16px]" />
      </div>
    </div>
  )
}

export default AccessDenied;